<template>
  <el-col
      :md="sz"
    class="field-space"
  >
    <el-row class="form-label">{{ label }}</el-row>
    <el-row class="rowItemInputStyle">
      <el-col :md="24">
        <el-row>
          <slot></slot>
        </el-row>
      </el-col>

    </el-row>
  </el-col>
</template>

<script>
export default {
  name: "s-form-item",
  props: {
    label: {type: String, default: null},
    sz: {default: 24},
    pl: {default: undefined},
  },

  methods: {},
};
</script>
<style>
.field-space{
  padding-top: 3px;
  margin-left: -1px;
  padding-left: 4px;
  background-color: rgba(14, 87, 99, 0.09);
}
.form-label {
  font-size: 11px;
  font-weight: bold;
}

.rowItemInputStyle {
  padding: 2px;
  /*padding-bottom: 2px;*/
}

.rowLabelInputStyle {
  padding-top: 1px;
  padding-bottom: 5px;
}

.rowLabelInputStyle svg {
  margin-top: 8px !important;
}
</style>
